import 'veui-theme-dls-icons/loading'
import config from 'veui/managers/config'

config.defaults(
  {
    icons: {
      loading: 'loading'
    },
    ui: {
      size: {
        values: ['xs', 's', 'm']
      }
    }
  },
  'switch'
)
